import { render, staticRenderFns } from "./AboutCritical.vue?vue&type=template&id=ac5826d4&scoped=true&"
import script from "./AboutCritical.vue?vue&type=script&lang=js&"
export * from "./AboutCritical.vue?vue&type=script&lang=js&"
import style0 from "./AboutCritical.vue?vue&type=style&index=0&id=ac5826d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5826d4",
  null
  
)

export default component.exports